import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StartupService } from './start-up.service';

@Injectable({
  providedIn: 'root',
})
export class HttpUtilService {
  loggedInUserData: any;
  BASE_URL = environment.baseUrl;
  HEADER_COLOUR: any;

  tokenApiData: any
  token: any

  dataHeaders:any
  constructor(
    private http: HttpClient,
    private startUpService: StartupService
  ) {
    this.tokenApiData = this.startUpService.startupData;
    this.token = this.tokenApiData?.access_token;
      this.dataHeaders = new HttpHeaders()
    .set('Authorization', 'Bearer ' + this.token)
    .set('Content-Type', 'application/json');

  }

  public postMethodwithResponseType(
    url: string,
    data: any,
    options?: any
  ): Observable<any> {
    return this.http.post(this.BASE_URL + url, data, {
      headers: this.dataHeaders,
      responseType: 'text',
    });
  }

  public get(url: string, options?: any): any {
    let spartacusToken = JSON.parse(localStorage.getItem('spartacus⚿⚿auth'));
    let dataHeadersOfSpartacus = new HttpHeaders()
      .set('Authorization', 'Bearer ' + spartacusToken?.token?.access_token)
      .set('Content-Type', 'application/json');
    return this.http.get(this.BASE_URL + url, {
      headers: spartacusToken?.token?.access_token
        ? dataHeadersOfSpartacus
        : this.dataHeaders,
        withCredentials: true
    });
  }

  public post(url: string, data: any, options?: any): Observable<any> {
    let spartacusToken = JSON.parse(localStorage.getItem('spartacus⚿⚿auth'));
    let dataHeadersOfSpartacus = new HttpHeaders()
      .set('Authorization', 'Bearer ' + spartacusToken?.token?.access_token)
      .set('Content-Type', 'application/json');
    return this.http.post(this.BASE_URL + url, data, {
      headers: spartacusToken?.token?.access_token
        ? dataHeadersOfSpartacus
        : this.dataHeaders,
        withCredentials: true
    });
  }

  public put(url: string, data: any, options?: any): any {
    let spartacusToken = JSON.parse(localStorage.getItem('spartacus⚿⚿auth'));
    let dataHeadersOfSpartacus = new HttpHeaders()
      .set('Authorization', 'Bearer ' + spartacusToken?.token?.access_token)
      .set('Content-Type', 'application/json');
    return this.http.put(this.BASE_URL + url, data, {
      headers: spartacusToken?.token?.access_token
        ? dataHeadersOfSpartacus
        : this.dataHeaders,
    });
  }

  public patch(url: string, data: any, options?: any): any {
    let spartacusToken = JSON.parse(localStorage.getItem('spartacus⚿⚿auth'));
    let dataHeadersOfSpartacus = new HttpHeaders()
      .set('Authorization', 'Bearer ' + spartacusToken?.token?.access_token)
      .set('Content-Type', 'application/json');
    return this.http.patch(this.BASE_URL + url, data, {
      headers: spartacusToken?.token?.access_token
        ? dataHeadersOfSpartacus
        : this.dataHeaders,
    });
  }
  public delete(url: string, options?: any): Observable<any> {
    let spartacusToken = JSON.parse(localStorage.getItem('spartacus⚿⚿auth'));
    let dataHeadersOfSpartacus = new HttpHeaders()
      .set('Authorization', 'Bearer ' + spartacusToken?.token?.access_token)
      .set('Content-Type', 'application/json');
    return this.http.delete(this.BASE_URL + url, {
      headers: spartacusToken?.token?.access_token
        ? dataHeadersOfSpartacus
        : this.dataHeaders,
    });
  }

  public getLoginUser(url: string, options?: any): Observable<any> {
    return this.http.get(this.BASE_URL + url);
  }
  public postToken(url: string, data: any, options?: any): Observable<any> {
    return this.http.post(url, data, options);
  }

   public  deleteWithBody(url: string, data: any): Observable<any>  {
     let environmentToken =  JSON.parse(localStorage.getItem('spartacus⚿⚿auth'));
    let dataHeadersOfSpartacus = new HttpHeaders()
      .set('Authorization', 'Bearer ' + environmentToken)
      .set('Content-Type', 'application/json');
      const headers = new HttpHeaders({ 'Content-Type': 'application/json' }); // Optional: set content type
     // return this.http.request('DELETE', url, { body: data, headers: headers });
        return this.http.request('DELETE',this.BASE_URL + url, { body: data,
      headers: environmentToken ? dataHeadersOfSpartacus : this.dataHeaders,
    });
    }
}
